function addProductToLastSeen() {
    
    if ( !$("#product-detail").length ) return
    
    let productId = $("#product-detail").data("product-id")
    
    if ( !productId ) return

    let lastSeenProducts = JSON.parse(localStorage.getItem("lastSeenProducts") || "[]")

    if ( !Array.isArray( lastSeenProducts ) ) lastSeenProducts = []

    if ( !lastSeenProducts ) lastSeenProducts = []
        
    if ( !lastSeenProducts.includes( productId ) ) {

        lastSeenProducts.push( productId )

    } else {

        lastSeenProducts = lastSeenProducts.filter(product => product !== productId)
        lastSeenProducts.push( productId )

    }

    if ( lastSeenProducts.length > 10 ) lastSeenProducts.shift()

    localStorage.setItem("lastSeenProducts", JSON.stringify(lastSeenProducts))

}

$(document).ready( function() {
    addProductToLastSeen()
})